// Router
import { replace } from "react-router-redux";
import { BASE_URL } from "../../config/constants";
// API
import { put } from "../../services/api";
// Ducks
import { setIsPasswordIntendedToChange } from "../../services/auth.ducks";
import { hideSpinner, showSpinner } from "../../services/spinner.ducks";
import { setErrorNotification } from "../../components/SmartNotification/SmartNotification.ducks";

// eslint-disable-next-line import/prefer-default-export
export const changePassword = (password) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await dispatch(put(`/user/password`, { password }));
    dispatch(setIsPasswordIntendedToChange(false));
    dispatch(hideSpinner());
    dispatch(replace(`${BASE_URL}/one_time_profile`));
  } catch (err) {
    let message;

    if (err.response && err.response.data && err.response.data.message) {
      switch (err.response.data.message) {
        case `users.password.post.error.allowedSpecialCharacters.notFound`:
          message = `modules.localization.register.anonymous.error.allowedSpecialCharacters.notFound`;
          break;
        case `users.password.post.error.candidate.notFound`:
          message = `modules.localization.register.authenticated.error.candidate.notFound`;
          break;
        case `users.password.post.error.cannotBeEmptyOrNull`:
          message = `modules.localization.register.anonymous.error.cannotBeEmptyOrNull`;
          break;
        case `users.password.post.error.forbiddenSpecialCharacters.found`:
          message = `modules.localization.register.anonymous.error.forbiddenSpecialCharacters.found`;
          break;
        case `users.password.post.error.needsLowercaseCharacters`:
          message = `modules.localization.register.anonymous.error.needsLowercaseCharacters`;
          break;
        case `users.password.post.error.needsNonNumericCharacters`:
          message = `modules.localization.register.anonymous.error.needsNonNumericCharacters`;
          break;
        case `users.password.post.error.needsNumericCharacters`:
          message = `modules.localization.register.anonymous.error.needsNumericCharacters`;
          break;
        case `users.password.post.error.needsUppercaseCharacters`:
          message = `modules.localization.register.anonymous.error.needsUppercaseCharacters`;
          break;
        case `users.password.post.error.tooLong`:
          message = `modules.localization.register.anonymous.error.tooLong`;
          break;
        case `users.password.post.error.tooShort`:
          message = `modules.localization.register.anonymous.error.tooShort`;
          break;

        default:
          message = `modules.localization.register.anonymous.smartNotifications.error.generic`;
          break;
      }
    }

    dispatch(
      setErrorNotification({
        messageTranslationKey: message,
        titleTranslationKey: `modules.localization.register.anonymous.smartNotifications.error.error`
      })
    );
    dispatch(hideSpinner());
  }
};
